import { CByteArray } from "./CByteArray";

export class CPacket extends CByteArray {
    private m_Length:number;
    private m_Position:number;
    public m_tm:number;
    public m_ID:number;
    public m_cntTry:number;

    constructor(length:number) {
		super(length);
		this.m_Length = 0;
		this.m_Position = 0;
        this.m_tm = 0;
        this.m_cntTry = 0;
        this.m_ID = 0;
	}

    public resetP(): void {
        //super.Reset(v);
        this.m_Length = 0;
        this.m_Position = 0;
    }

    //public set length(v:number) { this.m_Length = v; }
    //public set position(v:number) { this.m_Position = v; }
    public get size():number { return this.m_Length; }
    public get position():number { return this.m_Position; }
    //public get Bytes():Uint8Array { return this.m_Bytes; }

    public WriteChar(v:number):void {
		this.m_View.setInt8(this.m_Position, v);
        this.m_Position ++;
        this.m_Length ++;
    }

	public WriteShort(v:number):void {
        this.m_View.setInt16(this.m_Position, v, true);
        this.m_Position += 2;
        this.m_Length += 2;
    }

    public WriteInt(v:number):void {
        this.m_View.setInt32(this.m_Position, v, true);
        this.m_Position += 4;
        this.m_Length += 4;
    }

	public WriteByte(v:number):void {
        this.m_View.setUint8(this.m_Position, v);
        this.m_Position ++;
        this.m_Length ++;
    }

    public WriteBytes(src:Uint8Array, ofs:number, size:number):void {
		for(var i = 0; i < size; i ++) {
			this[this.m_Position++] = src[ofs++];
		}
        this.m_Length += size;
	}

	public WriteWord(v:number):void {
        this.m_View.setUint16(this.m_Position, v, true);
        this.m_Position += 2;
        this.m_Length += 2;
    }

    public WriteDWord(v:number):void {
        this.m_View.setUint32(this.m_Position, v, true);
        this.m_Position += 4;
        this.m_Length += 4;
    }

    public WriteUTFBytes(value:string, length:number):void {
        var len:number = this.SetUTFBytes(this.m_Position, value);
        this.m_Position += length;
        this.m_Length += length;
	}
}